/*@jsxRuntime automatic*/
/*@jsxImportSource react*/
import {useMDXComponents as _provideComponents} from "nextra/mdx";
const title = "Events Token";
const frontMatter = {};
import {Alert, Icon} from '@/components';
export function useTOC(props) {
  return [];
}
function MDXLayout(props) {
  const _components = {
    a: "a",
    p: "p",
    ..._provideComponents(),
    ...props.components
  };
  return <Alert severity="info"><_components.p>{"This API token differs from an API token that’s generated when creating\na "}<_components.a href="/administer/accounts-teams/service-accounts">{"service account"}</_components.a>{"."}</_components.p></Alert>;
}

export default MDXLayout